import {get, deleteRequest, post, put } from './api'
import { getServerInfo } from '../utils/helpers/networkInfo.helper';

const serverUrl = getServerInfo('api');
export class CoursesService {
    
    static getAll(token, queryParams = {}) {
        return get(`${serverUrl}courses`, token, queryParams)
    }

    static getById(id, token) {
        return get(`${serverUrl}courses/${id}`, token)
    }

    static bulkDelete(ids, token) {
        return deleteRequest(`${serverUrl}courses`, { ids }, true, token)
    }

    static delete(id, token) {
        return deleteRequest(`${serverUrl}courses/${id}`, null, false, token)
    }

    static create(data, token) {
        return post(`${serverUrl}courses`, data, true, token)
    }

    static update(id, data, token) {
        return put(`${serverUrl}courses/${id}`, data, true, token)
    }

    static getcoursesxprograms(id, token) {
        return get(`${serverUrl}coursesxprograms/${id}`, token)
    }

    static getcoursesxUserE(id, token) {
        return get(`${serverUrl}coursesxUserE/${id}`, token)
    }

}